import { useEffect } from 'react';

const useDocumentTitle = (title) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${title} | Agents Dashboard`;

    // Cleanup function to reset title when component unmounts
    return () => {
      document.title = prevTitle;
    };
  }, [title]);
};

export default useDocumentTitle;